export const EVENTS_LOADED = 'Events/EVENTS_LOADED';
